module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Thin.d39dcc2e.eot";